enum ButtonThemes {
  DOWNLOAD = 'download',
  NOBG = 'nobg',
  WHITE = 'white',
  DOWNLOAD_NOBG = 'downloadNoBg'
}

export default ButtonThemes
